import { useState } from "react";
import { TablePreviewResponse, TablePreviewVariant } from "~/components/table-preview/types";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const PAGE_SIZES: Record<TablePreviewVariant, number> = {
  [TablePreviewVariant.COMPACT]: 10,
  [TablePreviewVariant.FULL]: 25,
};

export function useTablePreview(tableFqn: string, variant: TablePreviewVariant) {
  const [pageIndex, setPageIndex] = useState(0);
  const pageSize = PAGE_SIZES[variant];
  const offset = pageIndex * pageSize;

  const key = tableFqn
    ? `${VITE_CATALOG_API}/tables/fqn/${encodeURIComponent(tableFqn)}/query?offset=${offset}&limit=${pageSize}`
    : null;

  const { data, isLoading, error } = useFetcher<TablePreviewResponse>(key, {
    shouldCamelize: true,
    skipCamelizeKeys: ["items"],
  });

  return { data, isLoading, error, pageIndex, pageSize, setPageIndex };
}
